var FuzzyReaction = require('../bootstrap').FuzzyReaction;
var AppDispatcher = FuzzyReaction.Dispatcher;
var AppActionConstants = require('../constants/AppActionConstants');
var assign = require('object-assign');
var ModelStore = FuzzyReaction.Stores.ModelStore;
var CmsActionTypes = FuzzyReaction.Constants.ActionTypes.cms.requests;

var AlbumsActionTypes = AppActionConstants.ActionTypes.albums;
/**
 * Data stores
 * @type {Array}
 * @private
 */
// Store for user table data
var _resourceListData = [];
var _albumSearchResult = {};
var _newlyCreatedTrack = {};
var _uploadProgress = {};
var _allAlbums = [];

/**
 * User store logic
 *
 * @type {*|exports}
 */
var TracksStore = assign({}, ModelStore, {
	getResourceListData: function () {
		return _resourceListData;
	},

	getAlbumSearchResults: function () {
		return _albumSearchResult;
	},

	getAllAlbums: function(){
		return _allAlbums;
	},

	// @todo this is kind of a hacky way to force a transition back
	getNewlyCreatedTrack: function () {
		return _newlyCreatedTrack;
	},

	getUploadProgress: function () {
		return _uploadProgress;
	},

	cleanAbumSearchResults: function (){
		_albumSearchResult = {};
		return _albumSearchResult;
	}
});

/**
 * Event Listeners
 */
TracksStore.dispatchToken = AppDispatcher.register(function(action) {
	switch(action.type) {
		case 'TRACKS_LISTED':
			_resourceListData = action.data;

			TracksStore.emitChange();
			break;
		case 'ALBUMS_RECEIVED':
			_albumSearchResult = action.data; // @todo are we only ever returning 1 result?

			TracksStore.emitChange();
			break;
		case 'TRACKS_CREATED':
			_newlyCreatedTrack = action.data;

			TracksStore.emitChange();
			break;
		case CmsActionTypes.UPLOAD_PROGRESS:
			_uploadProgress = action.data;

			TracksStore.emitChange();
			break;
		case 'ALBUMS_LISTED':
			_allAlbums = action.data;

			TracksStore.emitChange();
			break;
	}
});

module.exports = TracksStore;
